import React from "react";

const Header = () => {
    return (
        <h1 className='header'>
            Share your happy thoughts
            <div className="wrapper">
                <div className="container">
                    <div className="heart-pulse">
                    </div>
                </div>
            </div>
        </h1>
    );
}

export default Header